import { Fragment } from 'react';

import BaseComponent from '@tock/shared/components/BaseComponent';

interface Props {
  additionalConditional: boolean;
  children: JSX.Element;
}

export default class HideFromIOS extends BaseComponent<Props> {
  render() {
    const { additionalConditional, children } = this.props;
    const isReactNativeIos =
      BROWSER && window.ReactNative && window.ReactNative.platformOs === 'ios';
    return isReactNativeIos && additionalConditional ? <Fragment /> : children;
  }
}
